import { Route, Routes } from "react-router-dom";
import Login from "../../pages/vendorManager/auth/Login";
import Dashboard from "../../pages/vendorManager/Dashboard";
import Product from "../../pages/vendorManager/Product";
import Orders from "../../pages/vendorManager/Order";
import OrderDetails from "../../components/vendorManager/order/OrderDetails";
import MenuPricing from "../../pages/vendorManager/menu-pricing/MenuPricing";
import ExcelImportProducts from "../../pages/vendorManager/product/ExcelImportProducts";
import ScanOrder from "../../pages/vendorManager/order/ScanOrder";
import Setting from "../../pages/vendorManager/Setting";
import ForgotPassword from "../../pages/vendorManager/auth/ForgotPassword";

const index = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      
      <Route path="/products" element={<Product />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/scan-orders" element={<ScanOrder />} />
      <Route path="/order-details/:id" element={<OrderDetails />} />
      <Route path="/menu-excel" element={<MenuPricing />} />

      <Route path="/excel-products/:id" element={<ExcelImportProducts />} />
      <Route path="/excel-products" element={<ExcelImportProducts />} />

      <Route path="/setting" element={<Setting />} />

      
      
    </Routes>
  );
};
export default index;
